import { toEnglishDigits } from '../format/numbers';

/** Iranian national ID (کد ملی) checksum — ported from `nationalCodeValidator`. */
export function isValidNationalCode(input: string): boolean {
  const value = toEnglishDigits(input.trim());
  if (!/^\d{10}$/.test(value)) return false;
  if (new Set(value).size === 1) return false;
  const digits = [...value].map(Number);
  const sum = digits.slice(0, 9).reduce((acc, d, i) => acc + d * (10 - i), 0);
  const remainder = sum % 11;
  const check = digits[9];
  return remainder < 2 ? check === remainder : check === 11 - remainder;
}

/** Iranian mobile: 09xxxxxxxxx */
export const isValidMobile = (input: string): boolean =>
  /^09\d{9}$/.test(toEnglishDigits(input.trim()));

/** Normalises +98 / 0098 / 98 prefixes to the local `09…` form. */
export function normalizeMobile(raw: string): string | null {
  let digits = toEnglishDigits(raw).replace(/\D/g, '');
  if (digits.startsWith('0098')) digits = `0${digits.slice(4)}`;
  else if (digits.startsWith('98') && digits.length >= 12) digits = `0${digits.slice(2)}`;
  if (!digits) return null;
  return digits.slice(0, 11);
}

export const isValidCardNumber = (input: string): boolean =>
  /^\d{16}$/.test(toEnglishDigits(input.trim()));
